<div>

  <div
    style="font-family: 'Roboto';background: url('../assets/img/signup-background.jpg');background-size: cover;background-repeat: no-repeat">
    <div class="container shippn-homepage-container signup-background-woman">
      <div class="row">
        <div class="col-md-6 offset-md-6">
          <div class="row">
            <div style="text-align: left;margin-top: 20px;" class="col-md-12">
              <h5 style="font-weight: 400;font-size: 14px;">Already have an account? <a
                  [routerLink]="['/', 'signin']">Sign in</a> now!
              </h5>
              <h1 style="font-weight: bold;font-size: 22px;">Create Your Account</h1>
            </div>
          </div>
          <form ngNativeValidate [formGroup]="form">
            <div class="row">
              <div style="margin-top: 15px;" class="col-md-6">
                <div class="input_container">
                  <input (keypress)="keyPressAlphabethic($event)" id="only-text" formControlName="firstName"
                    [ngClass]="{'shippn-border-red':form.get('firstName').touched && form.get('firstName').invalid}"
                    type="text" name="first-name" required minlength="2" class="form-control shippn-input bg-white"
                    placeholder="Name">
                  <i *ngIf="form.get('firstName').touched && form.get('firstName').invalid" id="input_img"
                    class="fas fa-times" style="right: 19px; bottom: 26px;"></i>
                  <p style="font-size: 12px; margin: 0;"
                    *ngIf=" form.get('firstName').touched && form.get('firstName').invalid">
                    Please enter your first name
                  </p>
                </div>
              </div>
              <div style="margin-top: 15px;" class="col-md-6">
                <div class="input_container">
                  <input (keypress)="keyPressAlphabethic($event)" name="surname" formControlName="lastName" required
                    minlength="2" type="text"
                    [ngClass]="{'shippn-border-red':form.get('lastName').touched && form.get('lastName').invalid}"
                    class="form-control shippn-input bg-white" placeholder="Last Name">
                  <i *ngIf="form.get('lastName').touched && form.get('lastName').invalid" id="input_img"
                    class="fas fa-times" style="right: 19px; bottom: 26px;"></i>
                  <p style="font-size: 12px; margin: 0;"
                    *ngIf=" form.get('lastName').touched && form.get('lastName').invalid">
                    Please enter your last name
                  </p>
                </div>
              </div>
            </div>

            <div class="row">
              <div style="margin-top: 15px;" class="col-md-6">
                <div class="input_container">
                  <input style="padding-right: 35px;" formControlName="email"
                    [ngClass]="{'shippn-border-red':form.get('email').touched && form.get('email').invalid}" required
                    type="email" class="form-control shippn-input bg-white" placeholder="Email">
                  <i style="right: 19px; bottom: 26px;" *ngIf="form.get('email').touched && form.get('email').invalid"
                    id="input_img" class="fas fa-times email-i"></i>
                  <p style="font-size: 12px; margin: 0;"
                    *ngIf=" form.get('email').touched && form.get('email').invalid">
                    Please enter your email
                  </p>
                </div>
              </div>
              <div style="margin-top: 15px;" class="col-md-6">
                <div class="select--wrapper bg-white b-rad-5">
                  <i class="fas fa-chevron-down"
                    style="position: absolute; right: 10px; top: 20px;float: right; color: #222222;font-size: 12px;"
                    aria-hidden="true"></i>
                  <select formControlName="country"
                    style="width: 100%; border-radius: 5px;padding:12px 15px !important;background-color: white;height: 43px;"
                    class="form-select  shippn-input form-control-sm" aria-label=".form-select-lg example">
                    <option *ngFor="let country of counrtyList;" value="{{country.code}}"><span
                        *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-12 passwords-wrapper-box">
                <div class="row passwords-wrapper">
                  <!-- Password -->
                  <div class="col-md-6">
                    <div class="input_container password_container">
                      <input formControlName="password"
                        [ngClass]="{'shippn-border-red':form.get('password').touched && form.get('password').invalid || form.errors?.passwordsDoNotMatch}"
                        name="signupPassword" required type="password" class="form-control shippn-input bg-white "
                        placeholder="Password" minlength="6" (keyup)="writingPassword($event)">
                      <i style="right: 19px; top: 12px;"
                        *ngIf="form.get('password').touched && form.get('password').invalid" id="input_img"
                        class="fas fa-times password-i"></i>

                      <p style="font-size: 12px; margin: 0;"
                        *ngIf=" form.get('password').value?.length < 6 && (form.get('password').touched && form.get('password').invalid)">
                        Password must be at least 6 characters.
                      </p>

                      <p *ngIf=" form.get('password').value?.length >= 6 && (form.get('repassword').touched && form.get('password').touched) && form.errors?.passwordsDoNotMatch"
                        style="font-size: 12px; margin: 0;">
                        Passwords do not match
                      </p>
                    </div>
                  </div>
                  <!-- Re-->
                  <div class="col-md-6 repassword">
                    <div class="input_container password_container">
                      <input formControlName="repassword"
                        [ngClass]="{'shippn-border-red':form.get('repassword').touched && form.get('repassword').invalid || form.errors?.passwordsDoNotMatch}"
                        name="signupRePassword" minlength="6" required type="password"
                        class="form-control shippn-input bg-white " placeholder="Re-Enter Password"
                        (keyup)="writingRePassword($event)">
                      <i style="right: 19px; bottom: 26px;"
                        *ngIf="form.get('repassword').touched && form.get('repassword').invalid" id="input_img"
                        class="fas fa-times password-i"></i>
                      <p style="font-size: 12px; margin: 0;"
                        *ngIf=" form.get('repassword').value?.length < 6 && (form.get('repassword').touched && form.get('repassword').invalid)">
                        Password must be at least 6 characters.
                      </p>

                      <p *ngIf=" form.get('repassword').value?.length >= 6 && (form.get('repassword').touched && form.get('password').touched) && form.errors?.passwordsDoNotMatch"
                        style="font-size: 12px; margin: 0;">
                        Passwords do not match
                      </p>
                    </div>
                  </div>
                  <!-- Password -->

                </div>
              </div>

              <div class="col-md-12">
                <password-strength-meter [password]="password"></password-strength-meter>
              </div>
              <!-- <div class="col-md-12" style="margin-top: 10px;">
                <div class="col-md-12 passwords-not-match"
                  style="margin-top: 10px;font-weight: 400; font-size: 12px; padding: 0;">
                </div>
                <p style="font-size:13px; font-weight: 400;">
                  Your password must be 6-20 characters long, contain letters and numbers, and must not contain spaces,
                  special characters, or emoji.
                </p>
              </div> -->

              <div style="margin-top: 15px;" class="col-md-12">
                <div style="display: inline-flex;" class="form-check">
                  <input formControlName="receiveCheckbox" style="width: 27px;height: 27px;margin-top: 0;"
                    class="form-check-input" type="checkbox" id="defaultCheck1">
                  <label style="margin-left: 15px;" class="form-check-label" for="defaultCheck1">
                    <p style="font-weight: 400;font-size: 13px;color: #000000a6;margin-bottom: 8px;">Keep me in the loop
                      with special offers, promotions and new services from Shippn by email and phone!</p>
                    <p style="font-weight: 400;font-size: 13px;color: #000000a6;margin-top: 15px;">By signing up, I
                      agree to the <a style="color: #007bff;cursor: pointer;" data-toggle="modal"
                        data-target="#termsModal">terms & conditions</a> and <a style="color: #007bff;cursor: pointer;"
                        data-toggle="modal" data-target="#privacyModal">privacy policy</a></p>

                  </label>
                </div>
              </div>
              <div style="margin-top: 15px;" class="col-lg-12 col-md-12">
                <ngx-recaptcha2 #captchaElem [siteKey]="googleRecapthaSiteKey" [useGlobalDomain]="false" (expire)="resetCaptcha()"
                (error)="resetCaptcha()"
                  formControlName="recaptcha">
                </ngx-recaptcha2>
                <span *ngIf="form.get('recaptcha').touched && form.get('recaptcha').invalid"
                  style="color: red;font-size: 14px;">This field is required.</span>
              </div>
              <div style="margin-top: 15px;" class="col-md-12" [ngClass]="{'webview-margin-fixer': platformisWebView}">
                <button *ngIf="!passingSignupData" (click)="signUp()" id="shippnSignUpBtn"
                  style="background-color: #ff6c36;padding: 8px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                  type="submit" class="btn">Get Your Free Address</button>

                <a *ngIf="passingSignupData"
                  style="background-color: #ff6c36;padding: 22px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                  type="button" class="btn btn-loading-white"></a>
              </div>

              

              <div style="margin-top: 15px; text-align: center;" class="col-md-6" *ngIf="!platformisWebView">
                <a (click)="loginWithFacebook()" id="facebookSignUpBtn"
                  style="font-size: 14px;padding: 6px 15px;display: flex;align-items: center;justify-content: center; gap: 10px; height: 40px;"
                  class="btn btn-facebook"><i class="fab fa-facebook-square" style="font-size: 24px;"></i>Connect with
                  Facebook</a>
              </div>
              <div style="margin-top: 15px;margin-bottom: 40px; text-align: center;" class="col-md-6"
                *ngIf="!platformisWebView" (click)="loginWithGoogle()" id="googleSignUpBtn">
                <div style="background-color: #f2f2f2; border: 1px solid #dedede; font-size: 14px;border-radius: 5px;cursor: pointer;"><img src="assets/img/sign_in/web_neutral_sq_na.svg" alt="" > Continue with Google</div>
                
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="signup-shippnpilot-section bg-white">
  <div class="container shippn-homepage-container">
    <div class="shippnpilot-signup-wrapper">
      <app-shippnpilot-widget [shippnpilotWidgetType]="'both'"></app-shippnpilot-widget>
    </div>
  </div>
</section>


<section class="signup-happy-members-section bg-white">
  <div class="signup-happy-members-section-heading">
    <h2>Happy Members Across 160 Countries Ship With Shippn</h2>
    <div class="happy-member-heading-rating">
      <img src="/assets/img/signup/groupedyellowstar@2x.png" alt="">
      <span>4.4 /5 Rating</span>
    </div>
  </div>
  <div class="happy-members-comments-wrapper">
    <div class="happy-members-comment-item" *ngFor="let member of happyMembers;">
      <div class="happy-member-pp">
        <img
          [src]="'https://d1we2hgzmci25y.cloudfront.net/assets/img/hello10-users/' + (member?.country_code) + '/' + (member?.pp_url) + '.webp'"
          alt="" class="happy-member-pp-img">
      </div>
      <div class="happy-member-content">
        <div class="happy-member-info">
          <h6 translate="no">{{member?.name}}</h6>
          <span>{{member?.country}}</span>
        </div>

        <div class="happy-member-comment-content">
          <p>
            {{member?.comment}}
          </p>
        </div>
      </div>
    </div>
  </div>

</section>

<section class="signup-how-it-works-section bg-white-grey">
  <div class="container shippn-homepage-container signup-how-it-works-container">
    <div class="signup-how-it-works-wrapper">
      <div class="signup-how-it-works-item">
        <div class="signup-how-it-works-item-image">
          <img loading="lazy" class="howitworks-getadress-img" src="../assets/img/signup-getadress-icon.png"
            alt="Signup get address icon, woman in map marker pointing house">
        </div>
        <div class="signup-how-it-works-item-content">
          <h4>Get An Address</h4>
          <p>
            Select a Shippn host in the country where you want to shop.
          </p>
          <p>
            No sign up or setup fees required!
          </p>
        </div>
      </div>

      <div class="signup-how-it-works-item">
        <div class="signup-how-it-works-item-image">
          <img loading="lazy" class="howitworks-shopfrom-img" src="../assets/img/signup-shop-from-store.png"
            alt="sign up shop form store, store in macbook">
        </div>
        <div class="signup-how-it-works-item-content">
          <h4>Shop Anywhere</h4>
          <p>
            At checkout, simply use your host's address as your delivery address.
          </p>
        </div>
      </div>

      <div class="signup-how-it-works-item">
        <div class="signup-how-it-works-item-image">
          <img loading="lazy" class="howitworks-receive-img" src="../assets/img/signup-receive-icon.png"
            alt="signup receive icon, human sizes shopping bags">
        </div>
        <div class="signup-how-it-works-item-content">
          <h4>Receive Your Items</h4>
          <p>
            Get your packages delivered by our trusted partners: DHL, TNT, UPS and FedEx. Save up to 70% on shipping
            costs!
          </p>
        </div>
      </div>


    </div>
  </div>
</section>








<!-- Privacy Modal-->
<div class="modal fade" id="privacyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privacy Policy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <privacy-content [maxHeight]="500" [textColorClass]="'black-text'"></privacy-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Privacy Modal-->



<!-- Modal -->
<div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <terms-content [maxHeight]="500" [textColorClass]="'black-text'"></terms-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<button style="width:0; height:0; display: none;" id="socialUpdateModalTriggerBtn" data-toggle="modal"
  data-target="#socialUpdateModal"></button>
<!-- Social Update Modal -->
<div class="modal fade" id="socialUpdateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div style="background: #222222;" class="modal-header">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">Update Profile
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>

      <form ngNativeValidate [formGroup]="socialUpdateForm">
        <div style="padding-left: 50px;padding-right: 50px;" class="modal-body">

          <div class="row">
            <div class="col-md-12">
              <p style="margin-bottom: 0px;font-size: 16px;font-weight: 300;text-align: left;">
                Enter your email address
              </p>
            </div>
          </div>


          <div class="row">
            <div style="margin-top: 10px;" class="col-12 col-lg-12">
              <p style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                Email</p>
              <input type="email" formControlName="email"
                [ngClass]="{'shippn-border-red':socialUpdateForm.get('email').touched && socialUpdateForm.get('email').invalid}"
                placeholder="Email" class="form-control form-control-sm shippn-input">
            </div>
          </div>

          <div class="row">
            <div style="margin-top: 10px;" class="col-md-12">
              <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;"
                (click)="updateSocialLoginProfile()" class="btn shippn-from-to-area-go-btn">Save</button>
            </div>
          </div>

        </div>


      </form>

    </div>
  </div>
</div>

<!-- Facebook Authorization Waiting Modal-->
<button style="width:0; height:0; display: none;" id="facebookLoginStatusModalBtn" data-toggle="modal"
  data-target="#facebookLoginStatusModal"></button>
<!-- Modal -->
<div class="modal fade" id="facebookLoginStatusModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #222222;">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
          Connect with Facebook </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="text-align: left;max-height: 500px;overflow-y: auto;" class="col-md-12">
          <div style="color: #0f0f0f;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;"
            *ngIf="!facebookLoginErrorMessage">
            <p style="text-align:center;">
              Waiting for Facebook authorization.
            </p>
            <div
              style="background-image: url(../../assets/img/loading-black.gif);background-repeat: no-repeat;background-position: center;height: 35px;width: 100%;">
            </div>
          </div>
          <p *ngIf="facebookLoginErrorMessage"
            style="color: #0f0f0f; font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
            {{facebookLoginErrorMessage}}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;" data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn pull-right" id="facebookLoginCloseModalBtn">Close</button>
      </div>
    </div>
  </div>
</div>






<script>
  function test(event) {
    var char = event.which;
    if (char > 31 && (char < 65 || char > 90) && (char < 97 || char > 122)) {
      return false;
    }
  }

  function emailKeyValidation(event) {
    var char = event.which;

    if (char > 31 && char != 46 && (char < 48 || char > 57) && (char < 64 || char > 90) && (char < 97 || char > 122)) {
      return false;
    }
  }
</script>